import React, { Component } from 'react';
import { css } from 'emotion';
import { fadeInDown } from '@vromo/ui/styles/animated';

export default function Error404() {
    return (
        <>
            <div style={{ flex: 1 }}>
                <div
                    className={css`
                        animation: ${fadeInDown} 1.2s ease-in;
                    `}
                    style={{ textAlign: 'center' }}>
                    <h1 style={{ fontSize: 100, fontWeight: 300 }}>404</h1>

                    <h3 style={{ fontWeight: 500, fontSize: 32 }}>Page Not Found</h3>

                    <div>
                        The requested page couldn't be found. Try checking the URL for errors, then
                        hit the refresh button on your browser or try returning to the home page.
                    </div>
                </div>
            </div>
        </>
    );
}
